module.exports = __webpack_public_path__ + "static/img/swfxgl-logo.8122b13.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/views/appCenter/img/swfxgl-logo.png
// module id = SW5g
// module chunks = 96